import { Form, Row } from "antd";
import React from "react";

import { QueryStateCustomAttributeNameMap } from "../types";

import { Facet } from "./Facet";
import { ColFacet } from "./styled";
import { FacetsProps } from "./types";

export const Facets: React.FC<FacetsProps> = ({
  queryState,
  queryDispatch,
  facets,
}) => {
  const getFacetData = () => {
    return facets?.find(
      (facet) =>
        facet.query_var_name ===
        `string_custom_attribute["${QueryStateCustomAttributeNameMap.department}"]`
    );
  };

  return (
    <Form layout="vertical" name="facets">
      <Row gutter={24}>
        <ColFacet>
          <Facet
            handleChange={(v) => {
              queryDispatch({
                type: "update_custom_department",
                value: v as string,
              });
            }}
            value={queryState.department}
            resetLabel="Department"
            facetData={getFacetData()}
            hideValueInLabel={true}
            disabled={queryState.department?.length === 0 && !getFacetData()}
          />
        </ColFacet>
      </Row>
    </Form>
  );
};
